import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import './SectionApp.scss'; // Importando o estilo SCSS
import Button from '../../Button'; // Importando um componente Button, presumivelmente definido em '../../Button'

function SectionApp() {

  return (
    <section className="app-container" id='appSection'>

      {/* <div className='app-image'>
        <img src='https://pizza-prime.s3.sa-east-1.amazonaws.com/website/app.webp' />
      </div> */}
      <div className='app-info'>
        <div className='app-title'>
          Baixe o nosso app
        </div>
        <div className='app-description'>
          Aproveite promoções, cupons, ofertas, descontos e exclusividades que só tem no nosso app!
        </div>
        <div className='app-download'>
          <div className='store'>
            <Link to='https://apps.apple.com/br/app/pizza-prime-delivery/id1462955878'>
              <img src='img/baixe_app_apple.png' />
            </Link>
          </div>
          <div className='store'>
            <Link to='https://play.google.com/store/apps/details?id=app.accon.pizzaprime&hl=pt&pli=1'>
              <img src='img/baixe_app_play_store.png' />
            </Link>
          </div>
        </div>
      </div>
      <div className='qr-code'> 
        {/* <img src='https://pizza-prime.s3.sa-east-1.amazonaws.com/website/qrcode_pizza_prime.webp' /> */}
      </div>
      <div className='app-promo'>
        <div className='promo-title'>
          Use o código
        </div>
        <div className='promo-code'>
          SEJAPRIME
        </div>
        <div className='promo-off'>
          e ganhe
        </div>
        <div className='promo-discount'>
          R$ 20,00
        </div>
        <div className='promo-order'>
          no seu 1º Pedido
        </div>
      </div>
      
    </section>
  );
}

export default SectionApp;
